// extracted by mini-css-extract-plugin
module.exports = {"container":"RootError_container__qOj7s","message":"RootError_message__4Tt6F","homeButton":"RootError_homeButton__xYxfy"};